import { getMeta } from './helpers';

// Set webpack public asset url
window.__webpack_public_path__ = getMeta('theme-url');

import { Application } from '@hotwired/stimulus';
import AxiosFormController from './controllers/axios-form-controller';
import BlockAsyncController from './controllers/block-async-controller';
import CheckboxToggleController from './controllers/checkbox-toggle-controller';
import CookieBarController from './controllers/cookie-bar-controller';
import DatePickerController from './controllers/date-picker-controller';
import ExpandableController from './controllers/expandable-controller';
import LeafletController from './controllers/leaflet-maps-controller';
import ModalController from './controllers/modal-controller';
import SliderController from './controllers/slider-controller';
import TabController from './controllers/tab-controller';

require('./navigation');
require('./lightbox');

const application = Application.start();

application.register('block-async', BlockAsyncController);
application.register('axios-form', AxiosFormController);
application.register('checkbox-toggle', CheckboxToggleController);
application.register('cookie-bar', CookieBarController);
application.register('date-picker', DatePickerController);
application.register('modal', ModalController);
application.register('tab', TabController);
application.register('slider', SliderController);
application.register('expandable', ExpandableController);
application.register('leaflet', LeafletController);